// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4470":"ff3a02b73fc50cda","4721":"4d39d68cb0080f77","6345":"c405bc7c7f4635d0","6643":"82588921b13efcb7"}[chunkId] + ".js";
};